<template>
    <div class="headermenu">
        <div class="py-0 px-0 container">
            <div class="menubar">
                <div class="d-flex">
                    <v-list class="d-flex ma-0 pa-0">
                        <!-- <v-list-item class="flex-grow-0 flex-fill category ma-0 me-5 pa-0">
                            <v-list-item-title @click="showFullCategories" class="mt-1 pointer">
                                <i class="las fs-29" :class="isFullCategories ? 'la-times' : 'la-bars'"></i>
                            </v-list-item-title>
                        </v-list-item> -->
                        <v-list-item v-for="(item, i) in menuItems" :key="i" class="flex-grow-0 flex-fill">
                            <v-list-item-title>
                                <dynamic-link
                                    :to="item.href || (item.children && item.children[0] && item.children[0].href) || '/'"
                                    :append-class="{ 'text-reset fw-700': $route.path === item.href, 'text-reset fw-500': $route.path !== item.href }"
                                >
                                    <div class="px-2 py-5 me-1 position-relative" @mouseenter="viewSubMenu(i, 'inactive')" @mouseleave="hideSubMenu(i)">
                                        <font :color="item.colors">
                                            <div class="icon-floating"><i class="las lh-1 fs-20" :class="item.icon || ''"></i></div>
                                            <div class="fs-16" v-if="item.children && item.children.length">{{ item.name }}</div>
                                            <div class="fs-16" @mouseenter="hideAllSubMenu()" v-else>{{ item.name }}</div>
                                        </font>
                                    </div>
                                </dynamic-link>
                                <div
                                    class="sub_menus"
                                    v-bind:ref="'sub_menu' + i"
                                    v-on:mouseenter="viewSubMenu(i)"
                                    v-on:mouseleave="hideSubMenu(i)"
                                    v-if="item.children && item.children.length"
                                >
                                    <div class="sub-wrapper">
                                        <div class="container cstm-row">
                                            <div class="sub-list">
                                                <div>
                                                    <ul class="position-relative unstyled w-100">
                                                        <li
                                                            v-for="(sub_menu, j) in item.children"
                                                            :key="i + '_' + j"
                                                            class="sub-list-menus"
                                                            :class="{ 'no-hover': sub_menu.children && sub_menu.children.length }"
                                                            @mouseenter="showMenu($event, sub_menu.children)"
                                                        >
                                                            <dynamic-link :to="sub_menu.href || '/'" class="sub-list-link">
                                                                {{ sub_menu.name }}
                                                            </dynamic-link>
                                                            <img
                                                                v-if="sub_menu.children && sub_menu.children.length"
                                                                src="/assets/img/menu-arrow.svg"
                                                                class="sub-menu-arrow"
                                                            />
                                                            <ul v-if="sub_menu.children && sub_menu.children.length">
                                                                <li v-for="(sub_menu2, k) in sub_menu.children" :key="i + '_' + j + '_' + k">
                                                                    <dynamic-link :to="sub_menu2.href || '/'" class="sub-list-link2">
                                                                        {{ sub_menu2.name }}
                                                                    </dynamic-link>
                                                                </li>
                                                            </ul>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            <div class="right-side">
                                                <div>
                                                    <p>
                                                        환경친화적 인쇄를 지향하는
                                                        <br />
                                                        인쇄의 넘버원,
                                                        <strong>프리원!</strong>
                                                    </p>
                                                    <img src="/assets/img/soyinkmark.svg" alt="인증마크" />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list>
                </div>
                <div class="d-flex align-center right-icons">
                    <div class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <a href="/after-login/" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-home"></i>
                                </a>
                            </template>
                            <span>홈</span>
                        </v-tooltip>
                    </div>
                    <div v-for="(menu, i) in $optional('data.logobar_menu?.labels')" :key="i" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="$optional('data.logobar_menu.links')[i]" class="text-reset">
                                    <i class="las" v-bind="attrs" v-on="on" v-bind:class="$optional('data.logobar_menu.icons')[i]">
                                        <v-badge
                                            color="error"
                                            :content="getCartCount"
                                            inline
                                            v-if="getCartCount > 0 && $optional('data.logobar_menu.links')[i] === '/cart'"
                                            class="icon-badge"
                                            style="left: 1325px; top: -12px"
                                        ></v-badge>
                                    </i>
                                </router-link>
                            </template>
                            <span>{{ menu }}</span>
                        </v-tooltip>
                    </div>

                    <div v-if="!isAuthenticated" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="{ name: 'Login' }" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-in-alt"></i>
                                </router-link>
                            </template>
                            <span>로그인</span>
                        </v-tooltip>
                    </div>
                    <template v-else>
                        <div class="user-info-bar">
                            <span class="user-name">{{ currentUser.name }}</span><span v-if="currentUserCompany.company_name" class="user-company">({{ currentUserCompany.company_name }})</span>
                        </div>
                        <div class="icon-item">
                            <v-tooltip attach bottom transition="slide-y-transition">
                                <template v-slot:activator="{ on, attrs }">
                                    <router-link :to="{ name: 'Logout' }" class="text-reset">
                                        <i v-bind="attrs" v-on="on" class="las la-sign-out-alt"></i>
                                    </router-link>
                                </template>
                                <span>로그아웃</span>
                            </v-tooltip>
                        </div>
                    </template>
                </div>
            </div>
            <FullCategories :show="isFullCategories" ref="fullCategories" @close="closeFullCategories" />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    //import FullCategories from "./FullCategories.vue";
    import FullCategories from '../../../pages/custom/prione/FullCategories.vue';

    export default {
        props: {
            loading: { type: Boolean, required: true, default: true },
            data: {
                type: Object,
                default: {},
                current_path: '',
            },
        },
        watch: {
            // $route 객체를 감시하여 경로가 변경되었는지 확인
            $route(to, from) {
                //console.log('Route changed from', from.path, 'to', to.path);
                this.isFullCategories = false;
            },
        },
        data: () => ({
            isFullCategories: false,
        }),
        computed: {
            ...mapGetters('cart', ['getCartCount']),
            ...mapGetters('auth', ['isAuthenticated', 'currentUser', 'currentUserCompany']),
            ...mapGetters('app', ['demoMode']),
            // 거래처(shop_id)별 상단메뉴(메인/2차/3차옵션). setting/header API 응답(props.data.menu_items)에서 옴.
            // storage/docs/26-06-25-02-02-관리자-메인메뉴분리-Plan.md
            menuItems() {
                return (this.data && this.data.menu_items) || [];
            },
        },
        components: {
            FullCategories,
        },
        methods: {
            showFullCategories() {
                this.isFullCategories = !this.isFullCategories;
                // this.hideAllSubMenu();
            },
            closeFullCategories() {
                this.isFullCategories = false;
                // this.hideAllSubMenu();
            },
            viewSubMenu(i, inactive) {
                if (inactive === 'inactive') {
                    const targetMenu = document.querySelector('.active2');
                    if (targetMenu) targetMenu.classList.remove('active2');
                }

                const menuRef = 'sub_menu' + i;
                const element = this.$refs[menuRef][0];

                const subMenus = document.querySelectorAll('.sub_menus');
                subMenus.forEach((menu) => {
                    menu.classList.remove('active');
                    // menu.style.display = 'none';
                });

                element.classList.add('active');
                // element.style.display = 'block';

                this.closeFullCategories();
            },
            hideSubMenu(i) {
                const menuRef = 'sub_menu' + i;
                const element = this.$refs[menuRef][0];
                // element.style.display = 'none';
                element.classList.remove('active');

                this.closeFullCategories();
            },
            hideAllSubMenu() {
                const subMenus = document.querySelectorAll('.sub_menus');
                subMenus.forEach((menu) => {
                    // menu.style.display = 'none';
                    menu.classList.remove('active');
                });

                this.closeFullCategories();
            },
            showMenu(e, c) {
                if (!c || !c.length) {
                    const activeMenu = document.querySelector('.active2');
                    if (activeMenu) activeMenu.classList.remove('active2');
                } else {
                    e.currentTarget.classList.add('active2');
                }
            },
        },
    };
</script>
<style lang="scss" scoped>
    /* 전역 .v-application .container { margin-top: 150px } override */
    .container {
        margin-top: 0 !important;
    }

    .cstm-row {
        display: flex;
    }

    ::v-deep .sub_menus {
        position: absolute;
        left: 0;
        right: 0;
        top: 40px;
        z-index: 1001;
        padding-top: 24px;
        box-shadow: 0px 20px 30px -40px rgb(0 0 0 / 40%);
        transform: scale(0);
        opacity: 0;
        transition:
            opacity 0.5s,
            margin 0.5s,
            transform 0s 0.5s;
        pointer-events: none;

        &.active {
            transform: scale(1);
            margin-top: 0;
            opacity: 1;
            pointer-events: all;

            transition:
                opacity 0.5s,
                margin 0.5s;
        }

        .sub-list {
            h4 {
                margin-bottom: 12px;
            }
        }
    }
    ::v-deep .sub-wrapper {
        border-top: 1px solid #dddddd;
        position: relative;
        box-shadow: 0 -1px 1px #fff;
        padding: 20px 0 60px;

        background-color: #ffffff;

        & > div {
            justify-content: space-between;
        }

        ul {
            margin: 0;
            padding: 0;
            list-style: none;
        }

        .sub-list {
            width: 208px;
            border-right: 1px solid #e5e5e5;
            h3 {
                font-weight: 500;
                font-size: 16px;
                line-height: 130%;
                margin-bottom: 8px;
            }

            & > div {
                white-space: normal;

                &.over-2 > div:first-of-type > ul {
                    padding-bottom: 10px;
                    border-bottom: 2px dotted #e5e5e5;
                    margin-bottom: 10px;
                }

                & > div {
                    position: relative;
                }

                .sub-list-menus {
                    display: flex;
                    align-items: center;

                    .sub-menu-arrow {
                        margin-left: auto;
                        margin-right: 16px;
                    }
                }

                ul ul {
                    display: none;
                    position: absolute;
                    top: 0;
                    right: 0;
                    transform: translateX(100%);
                    padding-left: 20px;
                }

                ul {
                    display: inline-block;
                    vertical-align: top;

                    li {
                        margin-bottom: 8px;

                        &:not(.no-hover) a:hover {
                            font-weight: 500;
                            &:after {
                                width: 100%;
                            }
                        }

                        &.active2 {
                            .sub-list-link > a {
                                font-weight: 500;
                                &:after {
                                    width: 100%;
                                }
                            }

                            ul {
                                display: block;
                            }
                        }

                        /* &:hover ul{
                          display: block;
                      } */

                        span.special-green {
                            &:after {
                                content: url(/assets/img/header/quick-menu.svg);
                                margin-left: 1px;
                                position: relative;
                                top: 4px;
                            }
                            a {
                                color: #174f19;
                            }
                        }

                        .sub-list-link > a,
                        .sub-list-link2 > a {
                            font-size: 14px;
                            line-height: 100%;
                            color: #000;
                            position: relative;

                            &:after {
                                content: '';
                                position: absolute;
                                bottom: 0;
                                left: 0;
                                width: 0;
                                height: 2px;
                                background: #000;
                                transition: width 0.5s;
                            }
                        }

                        i {
                            width: 12px;
                            height: 12px;
                            border-radius: 50%;
                            align-items: center;
                            justify-content: center;

                            vertical-align: middle;

                            color: #fff;
                            font-size: 7px;

                            font-style: normal;
                            display: none;
                            position: relative;
                            top: -1px;

                            &.h-icon {
                                background: #c20000;
                            }
                            &.n-icon {
                                background: #3e7af2;
                            }
                            &.b-icon {
                                background: #127017;
                            }
                        }

                        &.h {
                            i.h-icon {
                                display: inline-flex;
                            }
                        }
                        &.n {
                            i.n-icon {
                                display: inline-flex;
                            }
                        }
                        &.b {
                            i.b-icon {
                                display: inline-flex;
                            }
                        }
                    }
                }
            }
        }

        .right-side {
            display: flex;
            align-items: flex-start;

            & > ul {
                display: flex;
                margin-right: 47px;

                & > li {
                    width: 300px;
                    margin-right: 10px;

                    &:last-of-type {
                        margin-right: 0;
                    }

                    img {
                        width: 100%;
                        display: block;
                        margin-bottom: 10px;
                    }
                    h4 {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 15px;

                        vertical-align: middle;

                        margin: 0;
                        margin-bottom: 6px;
                    }

                    .tag-list {
                        display: flex;
                        align-items: center;
                        margin-bottom: 5px;

                        li {
                            font-size: 12px;
                            line-height: 13px;

                            vertical-align: middle;
                            margin-right: 10px;

                            &:last-of-type {
                                margin-right: 0;
                            }
                        }
                    }

                    a {
                        font-weight: 500;
                        font-size: 14px;
                        line-height: 36px;

                        vertical-align: middle;
                        color: #3e7af2;
                    }
                }
            }
            & > div {
                text-align: right;

                p {
                    font-size: 14px;
                    line-height: 130%;

                    color: #1e5e2a;

                    strong {
                        font-weight: 500;
                    }

                    margin: 0 0;
                }

                img {
                    vertical-align: top;
                }

                a {
                    color: #3e7af2;
                }
            }
        }
    }

    .pointer {
        cursor: pointer;
    }

    .headermenu {
        position: relative;
        height: 64px;
    }
    .headermenu .v-list-item {
        /*서브메뉴 위치때문에*/
        position: static;
    }
    .headermenu .v-list-item + .v-list-item {
        margin-left: 35px;
        /**/
    }
    .headermenu .category {
        text-align: center;
        width: 32px;
        margin-left: -5px !important;
        border: 0 none;
        color: #000;
    }
    .headermenu .category a {
        color: #000;
    }
    .v-list-item {
        padding: 0 !important;
    }

    /* 오른쪽 아이콘 스타일 */
    .right-icons {
        margin-top: -2px;
        margin-right: -4px;
    }
    /* .icon-item {} */
    .icon-item a {
        font-size: 2rem;
        line-height: 1;
        display: block;
        text-align: center;
        margin: 0 4px;
        padding: 4px;
    }
    .icon-badge {
        position: absolute;
        top: -20px;
        right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
    }
    .icon-floating {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
    }

    .no-href {
        opacity: 0.4;
    }

    .sub-menu-title {
        font-weight: 500;
        font-size: 16px;
        line-height: 130%;
        color: #000 !important;
    }

    .headermenu {
        .menubar {
            display: flex;
            justify-content: space-between;
            height: 63px;
        }
    }

    .user-info-bar {
        display: flex;
        align-items: center;
        gap: 2px;
        margin-right: 8px;
        font-size: 13px;
        color: #222;
        white-space: nowrap;

        .user-name {
            font-weight: 600;
        }
        .user-company {
            font-weight: 400;
            color: #666;
        }
    }
</style>
